import { Button, Form, Input, Modal, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { toggleModal } from "../../../features/quizzes/quizzesSlice";
import { useEffect, useReducer, useState } from "react";
import { useAddQuizMarksMutation, useGetQuizMarkByStudentQuery } from "../../../features/quizMarks/quizMarksApi";
import { useNavigate } from "react-router-dom";


export default function QuizSubmitForm({ quizzes, video }) {
  const [visible, setVisible] = useState(0)
  const [quizAnswers, setQuizAnswers] = useState(quizzes)
  const navigate = useNavigate()

  const { user } = useSelector(state => state.auth)
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const { openModal } = useSelector(state => state.quizzes)

  const { data: submittedQuizzes } = useGetQuizMarkByStudentQuery({ studentId: user?.id, video_id: video?.video_id })
  const [addQuizMark, { isLoading, isSuccess, isError, error }] = useAddQuizMarksMutation()

  const submitHandler = (data) => {
    // const body = {
    //   student_id,
    //   student_name,
    //   video_id,
    //   video_title,
    //   totalQuiz,
    //   totalCorrect,
    //   totalWrong,
    //   totalMark,
    //   mark,
    // }

    // addQuizMark(body)
  }

  const cancelHandler = () => {
    dispatch(toggleModal(false));
    setVisible(0)
  }

  useEffect(() => {
    if (isSuccess) {
      cancelHandler();
      navigate('/leaderboard')
    }
  }, [isSuccess])

  useEffect(() => {
    console.info(quizAnswers)
  }, [])

  const prev = () => {
    if (visible == 0) return;
    setVisible(prev => prev - 1)
  }

  const next = () => {
    if (visible == quizzes.length - 1) {
      //submit
      return;
    };
    setVisible(prev => prev + 1)
  }

  const setAnswers = (quiz, option, value) => {
    console.info(value)
  }

  return (
    <>
      <Modal open={openModal} title={`Quiz : `}
        centered
        footer={false}
        onCancel={cancelHandler}>
        {
          submittedQuizzes?.length ?
            <div>
              <p>আপনি ইতিমধ্যে কুইজ জমা দিয়েছেন</p>
              <div>
                <p></p>
                <b>{submittedQuizzes[0]?.mark}</b>
              </div>
            </div>
            :


            <>
              {quizzes.map((quiz, index) => (
                <div key={quiz.id} hidden={index !== visible}>
                  <div>
                    <p>Question:</p>
                    <b>{quiz.question}</b>
                  </div>
                  <br />
                  <div>
                    <b>Options</b>
                    <br />

                    {
                      quiz.options?.map(option => (
                        <div key={option.id} className="flex gap-2 cursor-pointer py-2 items-center">
                          <input onChange={(e) => setAnswers(quiz, option, e.target.checked)} type="checkbox" id={option.id} />
                          <label htmlFor={option.id}>{option.option}</label>
                        </div>
                      ))
                    }
                  </div>
                </div>
              ))}

              <div className="w-full mt-10 flex justify-between items-center">
                <Button disabled={visible == 0} onClick={prev}>Previous</Button>
                <Button onClick={next}>{visible == quizzes.length - 1 ? 'Submit' : 'Next'}</Button>
              </div>
            </>

        }

      </Modal >
    </>
  )
}